import { cardItems } from '@/mocks/homeData';

const cardImages = [
  "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20battle%20scene%20with%20massive%20spaceships%2C%20nebulae%2C%20and%20laser%20beams%2C%20cinematic%20warm%20lighting%2C%20dramatic%20composition%2C%20film%20poster%20style%2C%20no%20text%2C%20professional%20movie%20concept%20art&width=700&height=400&seq=jiubo-card-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Intense%20drama%20scene%20set%20in%20urban%20Chinese%20city%2C%20strong%20emotional%20atmosphere%2C%20warm%20cinematic%20lighting%2C%20realistic%20photography%20style%2C%20deep%20shadows%2C%20no%20text%2C%20professional%20film%20still&width=700&height=400&seq=jiubo-card-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20scene%20with%20rainy%20night%20street%2C%20neon%20light%20reflections%2C%20suspenseful%20atmosphere%2C%20cinematic%20film%20noir%20style%2C%20warm%20amber%20accents%2C%20no%20text%2C%20professional%20cinematography&width=700&height=400&seq=jiubo-card-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%20with%20flowing%20silk%20curtains%2C%20warm%20lantern%20light%2C%20historical%20costume%20drama%20aesthetic%2C%20rich%20red%20and%20gold%20tones%2C%20no%20text%2C%20professional%20film%20set%20photography&width=700&height=400&seq=jiubo-card-04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Breathtaking%20arctic%20landscape%20with%20ice%20caves%20and%20aurora%20borealis%2C%20adventure%20film%20aesthetic%2C%20frozen%20wilderness%2C%20dramatic%20cold%20lighting%20with%20warm%20golden%20accents%2C%20no%20text%2C%20professional%20cinematography&width=700&height=400&seq=jiubo-card-05&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20school%20campus%20scene%20with%20cherry%20blossoms%20in%20spring%2C%20youth%20film%20aesthetic%2C%20soft%20golden%20sunlight%2C%20gentle%20atmosphere%2C%20cinematic%20color%20grading%2C%20no%20text%2C%20professional%20photography&width=700&height=400&seq=jiubo-card-06&orientation=landscape",
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            精选影片
          </h2>
          <p className="text-sm text-foreground-600">
            高分佳作，每一部都值得你花时间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((card, i) => (
            <div
              key={i}
              className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 flex flex-col"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={cardImages[i]}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 rounded-full text-[10px] md:text-xs font-medium whitespace-nowrap ${
                    card.tag === '热播中' || card.tag === 'HOT'
                      ? 'bg-primary-500 text-background-50'
                      : card.tag === '全网首发'
                      ? 'bg-accent-500 text-background-950'
                      : 'bg-background-950/70 text-background-50'
                  }`}>
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 bg-background-950/70 text-accent-400 rounded-lg px-2 py-1 flex items-center gap-1">
                  <i className="ri-star-fill text-xs"></i>
                  <span className="text-xs font-bold">{card.score}</span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {card.description}
                </p>
                <div className="mt-3 pt-3 border-t border-background-200/70 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>高清免费
                  </span>
                  <span className="text-xs font-medium text-primary-500 flex items-center gap-0.5 cursor-pointer group-hover:text-primary-600 transition-colors">
                    立即观看 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}